// extracted by mini-css-extract-plugin
module.exports = {"ctaCardText":"cta-card_ctaCardText__QaQVv","ctaCardButtons":"cta-card_ctaCardButtons__l10K7"};